import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IWeight } from 'app/shared/model/weight.model';
import { IGlucose } from 'app/shared/model/glucose.model';
import { IAppointments } from 'app/shared/model/appointments.model';
import { IVolunteerVisits } from 'app/shared/model/volunteer-visits.model';
import { IBloodDonation } from 'app/shared/model/blood-donation.model';
import { BPMethod } from 'app/shared/model/enumerations/bp-method.model';
import { OximetryMethod } from 'app/shared/model/enumerations/oximetry-method.model';
import { InOutUnits } from 'app/shared/model/enumerations/in-out-units.model';

export interface IVitals {
  id?: string;
  systolic?: number;
  diastolic?: number;
  bpMethod?: keyof typeof BPMethod | null;
  pulse?: number | null;
  oximetryMethod?: keyof typeof OximetryMethod | null;
  oximetry?: number | null;
  respiratoryRate?: number | null;
  bodyTemp?: number | null;
  bodySurfaceArea?: number | null;
  painScore?: number | null;
  liverFunction?: string | null;
  gfr?: string | null;
  cursor?: number;
  active?: boolean;
  microSec?: number;
  timestampentry?: number;
  lastupdated?: number;
  weight?: number | null;
  height?: number | null;
  cvp?: number | null;
  map?: number | null;
  intake?: number | null;
  output?: number | null;
  inOutUnits?: keyof typeof InOutUnits | null;
  glucoUser?: IGlucoUser;
  weightEntry?: IWeight | null;
  glucoseEntry?: IGlucose | null;
  appointment?: IAppointments | null;
  volunteerVisit?: IVolunteerVisits | null;
  bloodDonation?: IBloodDonation | null;
}

export const defaultValue: Readonly<IVitals> = {
  active: false,
};
